export const TV_ROW_WINDOW = 9

/** Keep the target near the entering edge so repeated D-pad moves have
 * look-ahead without mounting the full catalog row. */
export function virtualWindow(target: number, count: number, size = TV_ROW_WINDOW, direction: 'left' | 'right' = 'right') {
  const safeCount = Math.max(0, count)
  const windowSize = Math.max(1, Math.min(size, safeCount || 1))
  const maxStart = Math.max(0, safeCount - windowSize)
  const offset = direction === 'right' ? 2 : windowSize - 3
  const start = Math.max(0, Math.min(maxStart, target - offset))
  return { start, end: Math.min(safeCount, start + windowSize) }
}
